import { useQuery } from "@tanstack/react-query";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { SKUBarcodeColumns } from "./columns";
import { useEffect, useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { CSVLink } from "react-csv";
import { useTeamValue } from "providers/TeamContext";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { LoadingDialog } from "ui-components/Alert";
import { getSKUBarcodeEnquiry } from "services/data.report.service";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import dayjs from "dayjs";

function SKUBarcodeEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("Active");
  const active = status === "Active" ? true : false;
  const [filteredData, setFilteredData] = useState([]);
  const [columns, setColumns] = useState(SKUBarcodeColumns);
  const [tempColumn, setTempColumn] = useState(SKUBarcodeColumns);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  const exportPermission = allowAll || (Boolean(permissions["SKU Barcode_Report"]) && permissions["SKU Barcode_Report"].findIndex(b => b === "export") !== -1);

  const [alert, setAlert] = useState(null);

  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };
  const { refetch, isFetching } = useQuery({
    queryKey: ["sku-barcode-enquiry", { customerCode, active }],
    queryFn: () => getSKUBarcodeEnquiry({ customerCode, active }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      const result = data.data.data;
      if (result !== null) {
        const barcodes = Array.from(new Set(result.flatMap(sku => Object.keys(sku.barcodes))));
        const sortedBarcodeKeys = barcodes.sort((a, b) => {
          const order = ["BASE", "INNERPACK", "CASE", "PALLET"];

          const getTypeOrder = (key) => {
            for (let i = 0; i < order.length; i++) {
              if (key.startsWith(order[i])) return i;
            }
            return order.length;
          };

          const typeOrderComparison = getTypeOrder(a) - getTypeOrder(b);
          if (typeOrderComparison !== 0) return typeOrderComparison;

          const numA = parseInt(a.match(/\d+$/), 10);
          const numB = parseInt(b.match(/\d+$/), 10);
          return numA - numB;
        });
        const barcodeColumns = sortedBarcodeKeys.map(key => ({
          header: key,
          accessorKey: `${key}`,
        }));

        const indexPack = SKUBarcodeColumns.findIndex(x => x.accessorKey === "packType");
        let newArray = [...SKUBarcodeColumns];
        newArray.splice(indexPack, 0, ...barcodeColumns);
        setColumns(newArray);

        const flattenned = result.map(sku => {
          const { barcodes: barcodes2, ...details } = sku
          let temp = {}
          barcodeColumns.forEach(x => {
            const key = x.accessorKey
            temp[key] = ""
          })
          const updatedBarcode = {...temp,...barcodes2}
          return { ...details, ...updatedBarcode };
        })
        setData(flattenned);
        setFilteredData(flattenned);
      }
    },
    onError: () => { },
  });

  useEffect(() => {
    setTempColumn(columns);
  }, [columns])

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 1rem 1rem">
          <Grid container spacing={3}>
            <Grid item>
              <RadioGroup
                row
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
              >
                <FormControlLabel
                  labelPlacement="end"
                  value="Active"
                  label="Active"
                  control={<Radio checked={status === "Active"} />}
                />
                <FormControlLabel
                  labelPlacement="end"
                  value="Inactive"
                  label="Inactive"
                  control={<Radio checked={status === "Inactive"} />}
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={4}>
              {/* <MDButton variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink style={{ color: "white" }} filename={`SKU_Barcode`} data={filteredData}>
                  export
                </CSVLink>
              </MDButton> */}
              <MDButton
                variant="gradient" color="info" disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_SKUBarcode`;
                  downloadCsv(filename, filteredData)
                }}
              >
                export
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        <BasicTable data={data} columns={tempColumn} onFilterRowsChange={handleFilterRowsChange} />
      </TableCard>
    </ListLayout>
  );
}

export default SKUBarcodeEnquiry;
